import hook from '../../scripts/utilities/hook';

const FAQ_SELECTOR = hook('js-faq');
const BUTTON_SELECTOR = hook('js-faq-trigger');

const ACTIVE_CLASS = 'is-open';

class FAQ {
  constructor(element) {
    // early exist
    if (!element) {
      return;
    }
    this.element = element;

    this.initSelector();
    this.initListeners();
  }

  initSelector() {
    this.button = this.element.querySelector(BUTTON_SELECTOR);
  }

  initListeners() {
    this.button.addEventListener('click', () => {
      this.toggleCard();
    });
  }

  toggleCard() {
    this.element.classList.toggle(ACTIVE_CLASS);
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(FAQ_SELECTOR).forEach(faq => {
    // eslint-disable-next-line no-unused-vars
    const faqCard = new FAQ(faq);
  });
});
